import { render, staticRenderFns } from "./PublishingStatuses.vue?vue&type=template&id=6cf7b52b"
import script from "./PublishingStatuses.vue?vue&type=script&lang=js"
export * from "./PublishingStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports